import { render, staticRenderFns } from "./Wyrob.vue?vue&type=template&id=72ce678d&"
import script from "./Wyrob.vue?vue&type=script&lang=js&"
export * from "./Wyrob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports